import {request} from "@/api/request";
import {localStorageKey} from "@/api/config";

const LIVE_CHANNEL_DISPLAY_STORAGE_KEY = `${localStorageKey}-live-channel-display`;
const LIVE_CHANNEL_DISPLAY_CACHE_MS = 60 * 60 * 1000;
const LIVE_CHANNEL_DISPLAY_PLATFORMS = ['WEB', 'WEBOS'];

const getDefaultLiveChannelDisplay = () => ({
    WEB: {
        list: [],
        fetchedAt: 0,
    },
    WEBOS: {
        list: [],
        fetchedAt: 0,
    },
});

const getInitialLiveChannelDisplayState = () => {
    const defaultState = getDefaultLiveChannelDisplay();

    try {
        const storedValue = window.localStorage.getItem(LIVE_CHANNEL_DISPLAY_STORAGE_KEY);
        if (!storedValue) {
            return defaultState;
        }

        const parsedValue = JSON.parse(storedValue);
        return LIVE_CHANNEL_DISPLAY_PLATFORMS.reduce((result, platform) => {
            result[platform] = {
                list: parsedValue?.[platform]?.list || [],
                fetchedAt: parsedValue?.[platform]?.fetchedAt || 0,
            };
            return result;
        }, getDefaultLiveChannelDisplay());
    } catch (e) {
        return defaultState;
    }
};

const saveLiveChannelDisplayState = liveChannelDisplay => {
    window.localStorage.setItem(
        LIVE_CHANNEL_DISPLAY_STORAGE_KEY,
        JSON.stringify(liveChannelDisplay)
    );
};

const state = {
    filterSet: {
        filter:{},
        page: {
            page: 1,
            size: 0,
        },
        sort: {},
    },
    liveChannelDisplay: getInitialLiveChannelDisplayState(),
};

const getters  = {
    getFilterSet: state => state.filterSet,
    getLiveChannelDisplay: state => state.liveChannelDisplay,
};

const mutations = {
    updateFilterSet(state, obj) {
        state.filterSet = obj.data;
    },
    updateLiveChannelDisplay(state, {platform, list, fetchedAt}) {
        state.liveChannelDisplay = {
            ...state.liveChannelDisplay,
            [platform]: {
                list,
                fetchedAt,
            },
        };
        saveLiveChannelDisplayState(state.liveChannelDisplay);
    },
};

const actions = {
    setFilterSet({commit, rootState}, {data}) {
        commit('updateFilterSet', {data:data});
    },
    async ensureLiveChannelDisplay({state, commit}, {platform, force = false}) {
        const platformCache = state.liveChannelDisplay[platform];
        const now = Date.now();

        if (!force && platformCache && platformCache.fetchedAt > 0 && now - platformCache.fetchedAt < LIVE_CHANNEL_DISPLAY_CACHE_MS) {
            return platformCache.list;
        }

        try {
            const response = await request.javaGet(`v1/user/channel/display/${platform}`, {paging: false}).then(({data}) => data);
            const channelDisplayList = response?.result?.list || [];

            commit('updateLiveChannelDisplay', {
                platform,
                list: channelDisplayList,
                fetchedAt: now,
            });

            return channelDisplayList;
        } catch (e) {
            return platformCache?.list || [];
        }
    },
};

export default { namespaced: true, state, getters, mutations, actions }
